import cx from 'classnames';
import type { Item } from '../../../types/codexOrder';
import { FoodBarIcon } from '../../../assets/Icons';
import { formatMoney } from '../../../helpers/utils';

function OrderItems({ items }: { items: Item[] }) {
  if (!items || items.length === 0) {
    return null;
  }

  function getItemPrice(item: Item) {
    let itemPrice = item?.price || 0;
    item?.options_to_add?.forEach(option => {
      itemPrice += (option?.price || 0) * (option?.quantity || 1);
    });
    itemPrice *= item?.quantity || 1;
    return formatMoney(itemPrice);
  }

  return (
    <div className="p-4 rounded-lg bg-white mb-4">
      <div className="flex items-center gap-x-2 mb-5">
        <FoodBarIcon className="text-brand-icon" />
        <p className="font-bold">Items</p>
      </div>
      <div className="flex flex-col gap-y-5">
        {items?.map((item, idx) => {
          const hasOptions = !!item?.options_to_add?.length;
          return (
            <div
              className="flex items-start gap-x-2"
              key={item?.id?.toString() + idx?.toString()}>
              <p>
                <span>{item.quantity}</span> <span className="text-xs">x</span>
              </p>
              <div className="flex-1">
                <p>{item.title}</p>
                <p
                  className={cx(
                    'text-up-black-50 leading-6 text-sm',
                    hasOptions && 'mt-1',
                  )}>
                  {item?.options_to_add
                    ?.map(option => {
                      const qty =
                        option?.quantity > 1
                          ? `${String(option?.quantity)}x `
                          : '';
                      return qty + (option?.title || '');
                    })
                    ?.join(', ')}
                </p>
              </div>
              <p className="w-18 text-right text-up-black-50 text-sm">
                {getItemPrice(item)}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default OrderItems;
